import { useContext, useRef } from "react";
import LazyLoadImg from "../../../../elements/images/LazyLoadImg";
import { BsWhatsapp, BsPhone } from "react-icons/bs";
import { AiOutlineClose } from "react-icons/ai";
import Paragraph from "../../../../elements/p/Paragraph";
import modalContext from "../../../../../dataManager/context/modalContext";
import { toast } from "react-toastify";

const UserBox = ({ user }) => {
  //context variables
  const { handleOpenModal } = useContext(modalContext);

  const phoneRef = useRef();

  //copy the text content to the given element
  function copyUserPhone(domElementToCopy) {
    console.log(domElementToCopy.innerText);

    // Copy the text inside the text field
    navigator.clipboard.writeText(domElementToCopy.innerText);

    /* Alert the copied text */
    toast.success(`Le numéro ${user.getPhone} à été copié `, {
      theme: "colored",
    });
  }

  return (
    <article className="group flex items-center space-x-2 p-3 pt-2 hover:bg-smoot/40 ">
      <LazyLoadImg
        img={user.getImage}
        alt={user.getName}
        classe="w-9 h-9 object-cover rounded-full border-2 border-smoot group-hover:border-primary animate"
      />
      <div className="flex w-full items-center justify-between">
        <div>
          <Paragraph size="small">{user.getName}</Paragraph>
          <div className="mt-0.5 flex items-center space-x-1">
            <div className="flex items-center space-x-2">
              <a
                href={`https://wa.me/${user.getPhone.split("+")[1]}`}
                target="_blank"
                rel="noopener noreferrer"
                title="Envoyer un message via Whatsapp"
              >
                <BsWhatsapp
                  className="cursor-pointer text-secondary/80 opacity-80 hover:text-primary"
                  size={15}
                />
              </a>
              <a
                title="Appeler via son numéro de téléphone"
                href={`tel:${user.getPhone}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <BsPhone
                  className="cursor-pointer text-secondary/80  opacity-80 hover:text-primary"
                  size={16}
                />
              </a>
            </div>
            <span
              title="copier le numéro"
              onClick={() => copyUserPhone(phoneRef.current)}
              ref={phoneRef}
              className="cursor-pointer font-nunito text-[10px] text-secondary/75"
            >
              {user.getPhone}
            </span>
          </div>
        </div>
        <AiOutlineClose
          title="supprimer de la liste des utilisateurs à contacter"
          onClick={() =>
            handleOpenModal("CHANGE_USER_ALREADY_CONTACTED", "Rétirer ", {
              userId: user.getId,
            })
          }
          className="cursor-pointer text-secondary/80  opacity-80 hover:text-primary"
          size={16}
        />
      </div>
    </article>
  );
};

export default UserBox;
